import React, { FC, useEffect } from "react";
import "./personalDetailsCard.scss";
import { generatePath, RouteComponentProps, useHistory, withRouter } from "react-router-dom";
import backArrow from "../../../assets/icons/back_arrow.svg";
import avatarPlaceholder from "../../../assets/placeholder/avatar_placeholder.png";
import CardMenu from "../CourseComponents/CardMenu";
import genderIcon from "../../../assets/icons/gender.svg";
import calenderIcon from "../../../assets/icons/calendar.svg";
import degreeIcon from "../../../assets/icons/students-cap.svg";
import phoneIcon from "../../../assets/icons/phone.svg";
import mailIcon from "../../../assets/icons/mail.svg";
import moment from "moment";
import { STUDENT_ANALYTICS } from "../../../routes/routeConstants/appRoutes";

interface PersonalDetailsCardProps extends RouteComponentProps {
  type?: string;
  data?: any;
  handleEdit?: Function;
  handleDelete?: Function;
}

const PersonalDetailsCard: FC<PersonalDetailsCardProps> = (props: any) => {
  const { type, data, handleEdit, handleDelete } = props;
    const history = useHistory()

    useEffect(() => {
        console.log(data)
    }, [])
  return (
    <>
      <div className="personal-detail__back">
        <img src={backArrow} alt="" onClick={() => props.history.goBack()} />
      </div>
      <div className="personal-detail__card">
        <div className="personal-detail__card__header">
          <div className="personal-detail__card__image">
            <img src={data?.displayPictureUrl || avatarPlaceholder} alt="" />
          </div>
          <div className="personal-detail__card__name-info">
            <div className="personal-detail__card__name">{data?.fullName}</div>
            <div className="personal-detail__card__id">{data?.id}</div>
          </div>
          <div className="view__analytics"
          onClick={() => history.push(generatePath(STUDENT_ANALYTICS, {studentId: 1}))}
          >
              View Analytics
          </div>
          <div className="personal-detail__card__status">
            {type !== "student" ? (
              <>
                <span
                  className={`status__indicator ${
                    data?.isActive ? "active" : "inactive"
                  }`}
                />
                <span className="status">
                  {data?.isActive ? "Active" : "Inactive"}
                </span>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="personal-detail__card__menu">
            {type !== "student" ? (
              <CardMenu
                handleDelete={handleDelete}
                handleEdit={handleEdit}
                menuText={"Tutor"}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="personal-detail__card__details">
          <div className="personal-detail__details__section">
            <div
              className="personal-detail__card__info"
              style={{ textTransform: "capitalize" }}
            >
              <img src={genderIcon} alt="" className="gender-icon" />{" "}
              {data?.gender}
            </div>
            <div className="personal-detail__card__info">
              <img src={calenderIcon} alt="" className="calendar-icon" />{" "}
              {moment(data?.dateOfBirth).format("MMM DD,YYYY")}
            </div>
            <div className="personal-detail__card__info">
              <img src={degreeIcon} alt="" className="degree-icon" />{" "}
              {type === "student" ? "CBSE, class 5" : data?.qualification}
            </div>
          </div>
          <div className="personal-detail__details__section">
            <div className="personal-detail__card__info">
              {type !== "student" ? (
                <>
                  <img src={phoneIcon} alt="" className="phone-icon" /> +91{" "}
                  {data?.phoneNumber}
                </>
              ) : (
                <>
                  <div>
                    <img src={phoneIcon} alt="" className="phone-icon" />
                    <span>
                      +91 99999 99999 <span className="info-type">Student</span>
                    </span>
                  </div>
                  <div>
                    <span className="parent-info">
                      +91 11111 11111
                      <span className="info-type">Parent</span>
                    </span>
                  </div>
                </>
              )}
            </div>
            <div className="personal-detail__card__info">
              {type !== "student" ? (
                <>
                  <img src={mailIcon} alt="" className="mail-icon" />{" "}
                  {data?.email}
                </>
              ) : (
                <>
                  <div>
                    <img src={mailIcon} alt="" className="mail-icon" />
                    <span>
                      student@mail.com<span className="info-type">Student</span>
                    </span>
                  </div>
                  <div>
                    <span className="parent-info">
                      parent@mail.com
                      <span className="info-type">Parent</span>
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      
      </div>
    </>
  );
};

export default withRouter(PersonalDetailsCard);
